export enum Layout {
  DEFAULT = 'default',
  ADMIN = 'admin',
  AUTH = 'auth',
}
